import { useTranslations } from 'next-intl';
import { StatBankFilterType } from './StatBankFilters';
import DropdownFilter, { DropdownFilterOptionType, IDropdownFilter } from '../search/DropdownFilter';
import { useEffect, useState } from 'react';
import { assignValuesFromRouteQuery, pushValuesToRouteQuery } from '@/utils';
import { useRouter } from 'next/router';

type StatBankFilterOptionsProps = {
  availableFilters: StatBankFilterType[];
  facets: any[];
};

const StatBankFilterOptions = ({ availableFilters, facets }: StatBankFilterOptionsProps) => {
  const t = useTranslations();
  const router = useRouter();
  const [filters, setFilters] = useState<IDropdownFilter[]>([]);
  const [changeFilters, setChangeFilters] = useState<{ [key: string]: string[] }>();

  useEffect(() => {
    const filterFields: { [key: string]: string[] } = {};

    availableFilters.forEach((filter) => {
      filterFields[filter.key] = [];
    });

    assignValuesFromRouteQuery(router, filterFields);
    setChangeFilters(filterFields);
    buildFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableFilters, facets]);

  useEffect(() => {
    if (changeFilters) {
      const filterFields = { ...changeFilters };
      assignValuesFromRouteQuery(router, filterFields);
      setChangeFilters(filterFields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query]);

  const buildFilters = () => {
    const filters: IDropdownFilter[] = [];

    availableFilters.forEach((filter) => {
      const filterOb: IDropdownFilter = {
        name: filter.key,
        disabled: false,
        value: [],
        options: filter.options.map((option) => {
          const optionOb: DropdownFilterOptionType = {
            label: option.name,
            value: option.id,
            count: 0,
            disabled: false,
          };
          return optionOb;
        }),
      };

      filters.push(filterOb);
    });

    setFilters(filters);
  };

  const onChange = (filterName: string, value: string) => {
    const newFilterValues = { ...changeFilters };
    if (newFilterValues[filterName].includes(value)) {
      newFilterValues[filterName] = newFilterValues[filterName].filter((v) => v !== value);
    } else {
      newFilterValues[filterName].push(value);
    }
    pushValuesToRouteQuery(router, { ...newFilterValues, page: null });
  };

  const onClear = (filterName: string) => {
    const newFilterValues = { ...changeFilters };
    newFilterValues[filterName] = [];
    pushValuesToRouteQuery(router, { ...newFilterValues, page: null });
  };

  return (
    <div className="flex w-full flex-col items-center gap-2 md:flex-row md:gap-6">
      {changeFilters &&
        filters.map((filter) => (
          <DropdownFilter
            key={filter.name}
            value={changeFilters[filter.name]}
            name={t('search.$filterlabel' + filter.name.replace(/[\W_]+/g, ''))}
            options={filter.options}
            disabled={filter.disabled}
            onChange={(value) => onChange(filter.name, value)}
            onClear={() => onClear(filter.name)}
          />
        ))}
    </div>
  );
};

export default StatBankFilterOptions;
